/*============================================================================
  Cart Drawer Upsells
  - Blendet Kandidaten aus [data-cart-upsell] ein, die noch nicht im Warenkorb sind
  - 1-Klick Add-to-Cart, optional mit Varianten-Dropdown
  - Haengt sich an die bestehenden Motion-Cart-Events an
==============================================================================*/
(function () {
  'use strict';

  var SELECTORS = {
    root: '[data-cart-upsell]',
    item: '[data-cart-upsell-item]',
    variant: '[data-cart-upsell-variant]',
    price: '[data-cart-upsell-price]',
    add: '[data-cart-upsell-add]',
    error: '[data-cart-upsell-error]'
  };

  function cartAddUrl() {
    return (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
  }

  function cartUrl() {
    return (window.theme && theme.routes && theme.routes.cart) || '/cart.js';
  }

  function fetchCart() {
    return fetch(cartUrl() + '?t=' + Date.now(), {
      credentials: 'same-origin',
      method: 'GET',
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function CartUpsell(root) {
    this.root = root;
    this.max = parseInt(root.dataset.max, 10) || 2;
    this.items = Array.prototype.slice.call(root.querySelectorAll(SELECTORS.item));
    this.errorEl = root.querySelector(SELECTORS.error);
    this.pending = false;

    if (!this.items.length) return;

    this.bindEvents();
    this.refresh();
  }

  CartUpsell.prototype.bindEvents = function () {
    var self = this;

    this.root.addEventListener('click', function (evt) {
      var btn = evt.target.closest(SELECTORS.add);
      if (btn) {
        evt.preventDefault();
        self.addToCart(btn);
      }
    });

    this.root.addEventListener('change', function (evt) {
      var select = evt.target.closest(SELECTORS.variant);
      if (select) self.onVariantChange(select);
    });

    // Menge im Warenkorb geaendert oder Produkt entfernt
    document.addEventListener('cart:updated', function (evt) {
      self.refresh(evt.detail && evt.detail.cart);
    });

    // Produkt von einer Produktseite/Quick-Add hinzugefuegt
    document.addEventListener('ajaxProduct:added', function () {
      self.refresh();
    });
  };

  CartUpsell.prototype.onVariantChange = function (select) {
    var item = select.closest(SELECTORS.item);
    if (!item) return;

    var option = select.options[select.selectedIndex];
    if (!option) return;

    item.dataset.variantId = option.value;

    var priceEl = item.querySelector(SELECTORS.price);
    if (!priceEl) return;

    var compare = option.dataset.compare;
    var price = option.dataset.price || '';

    priceEl.innerHTML =
      (compare ? '<s class="cart-upsell__price-was">' + compare + '</s>' : '') +
      '<span class="cart-upsell__price-now">' + price + '</span>';
  };

  /*
    Zeigt bis zu this.max Kandidaten, die noch nicht im Warenkorb liegen.
    cart kann uebergeben werden (aus dem cart:updated-Event), sonst wird geladen.
  */
  CartUpsell.prototype.refresh = function (cart) {
    var self = this;

    if (cart && cart.items) {
      this.render(cart);
      return Promise.resolve();
    }

    return fetchCart()
      .then(function (freshCart) { self.render(freshCart); })
      .catch(function () { self.render(null); });
  };

  CartUpsell.prototype.render = function (cart) {
    var inCart = {};
    var itemCount = 0;

    if (cart && cart.items) {
      itemCount = cart.item_count || 0;
      cart.items.forEach(function (line) {
        inCart[line.product_id] = true;
      });
    }

    var shown = 0;

    this.items.forEach(function (item) {
      var productId = parseInt(item.dataset.productId, 10);
      var eligible = !inCart[productId] && shown < this.max;

      item.hidden = !eligible;
      if (eligible) shown++;
    }, this);

    // Bei leerem Warenkorb nichts anbieten
    this.root.hidden = shown === 0 || itemCount === 0;
    this.hideError();
  };

  CartUpsell.prototype.addToCart = function (btn) {
    var self = this;
    var item = btn.closest(SELECTORS.item);
    if (!item || this.pending) return;

    var select = item.querySelector(SELECTORS.variant);
    var variantId = select ? select.value : item.dataset.variantId;
    if (!variantId) return;

    this.pending = true;
    btn.disabled = true;
    btn.classList.add('is-loading');
    this.hideError();

    fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || '');
          }
          return data;
        });
      })
      .then(function () {
        // Motion baut den Drawer-Inhalt neu auf
        document.dispatchEvent(new CustomEvent('cart:build'));
        return fetchCart();
      })
      .then(function (freshCart) {
        self.render(freshCart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: freshCart } }));
      })
      .catch(function (err) {
        self.showError(err && err.message);
      })
      .finally(function () {
        self.pending = false;
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  };

  CartUpsell.prototype.showError = function (message) {
    if (!this.errorEl) return;
    this.errorEl.textContent =
      message || (window.theme && theme.strings && theme.strings.unavailable) || '';
    this.errorEl.hidden = !this.errorEl.textContent;
  };

  CartUpsell.prototype.hideError = function () {
    if (!this.errorEl) return;
    this.errorEl.textContent = '';
    this.errorEl.hidden = true;
  };

  function init() {
    document.querySelectorAll(SELECTORS.root).forEach(function (root) {
      if (root.dataset.cartUpsellReady === 'true') return;
      root.dataset.cartUpsellReady = 'true';
      new CartUpsell(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
